import {Component, OnInit, AfterViewInit} from '@angular/core';
import {StepComponent} from '../../step/step.component';
import {ModeratAnfrage} from '../anfrage/moderat.anfrage';
import {StepService} from "../../services/step.service";
import {Router} from "@angular/router";
import {ElementService} from "../../services/element.service";
import {ModeratRequestService} from "../services/request.service";
import {StepNavigationElement} from "../../step/step.navigation.element";
import {PortalService} from "../../services/portal.service";
import {VerbrauchsanalyseModeratForm} from "../verbrauchsanalyse/verbrauchsanalyse.moderat.form";
import {EnergyMapService} from "../../energy-map/services/energy.map.service";

/**
 * Special component for the start page of the chapter "verbrauchsanalyse". Only Textoutputs, no form.
 */
@Component({
    selector: 'app-moderat-wpcheck-start',
    templateUrl: './wpcheck.start.component.html',
    standalone: false
})
export class WpcheckStartComponent extends StepComponent implements OnInit, AfterViewInit {

  /**
   * the current anfrage of the user
   */
  anfrage: ModeratAnfrage;

  /**
   * URL for moving backwards to the WPC
   */
  static wpcheckUrl: string = '/{{portalId}}/wpcheck/ergebnis/analyse';

  /**
   * constructor
   * @param stepService
   * @param router
   * @param elementService
   * @param requestService
   * @param portalService
   */
  constructor(protected stepService: StepService, protected router: Router, protected elementService: ElementService,
              protected requestService: ModeratRequestService, protected portalService: PortalService,
              protected energyMapService: EnergyMapService) {
    super(stepService, router, elementService);
  }

  /**
   * @inheritDoc
   */
  ngOnInit() {
    super.ngOnInit();
    this.anfrage = this.requestService.getAnfrage();
    this.anfrage.mode = ModeratAnfrage.MODE_WPCHECK;
    this.requestService.setAnfrage(this.anfrage);

    // show navigation element back to the wpcheck
    this.stepService.setNavigationPreElement(
      new StepNavigationElement('moderat.nav.wpcheck.', true, WpcheckStartComponent.wpcheckUrl.replace('{{portalId}}', this.portalService.currentPortalId)
    ));

    // special case on this step: The next step is not fixed, we have to check which field is activa on one of the next steps
    this.formConfig = new VerbrauchsanalyseModeratForm(this.energyMapService);
    this.formConfig.getForm('');
    this.formConfig.setData(this.anfrage.verbrauchsanalyseInput);
    this.steps.nextStep = this.getNextStepFromList(this.steps.nextStepList, this.formConfig);
  }

  /**
   * @inheritDoc
   */
  ngAfterViewInit(): void {
    super.ngAfterViewInit();

    // scroll to the top
    const element = document.querySelector('body');
    this.elementService.scrollToElement(element);
  }
}
